<template>
  <div style="margin: 0;padding: 10px;">
    <b-card
      title="Input Groups with Buttons"
      no-body
      class="mb-0 pt-2 pl-2 pr-2 h-100"
    >
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="mb-1 mb-md-0"
        >
          <b-form-group
            label="Vendedor"
            label-for="vendedor"
            class="black-text"
          >
            <v-select
              v-model="vendedor"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="nombreCompleto"
              :options="selectVendedor"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Fecha del cuadre"
            label-for="fecha"
            class="black-text"
          >
            <b-form-datepicker
              id="example-datepicker"
              v-model="fecha"
              class="mb-1"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mt-2"
        >
          <b-button
            variant="primary"
            class="btn-icon"
            type="button"
            size="xs"
            @click="verCuadre"
          >
            Buscar
            <feather-icon icon="SearchIcon" />
          </b-button>
        </b-col>
        <!-- b-col
          v-for="(detalle, index) in listSalida"
          :key="index"
          md="6"
          class="d-flex justify-content-center align-items-center mt-1"
        >
          <b-button
            variant="primary"
            class="btn-icon"
            type="button"
            size="lg"
            @click="verResumenSalida(detalle)"
          >
            {{ detalle.codigo }}
            <feather-icon icon="SaveIcon" />
          </b-button>
        </b-col -->
        <b-col
          v-if="salida!= null"
          md="12"
        >
          <b-col
            md="12"
            class="d-flex justify-content-center align-items-center mt-1"
          >
            <h2>{{ salida.codigo }}</h2>
          </b-col>
          <b-col class="d-flex justify-content-center align-items-center">
            <b-col
              cols="12"
              md="3"
              class="mt-1"
            >
              <b-form-group
                label="Chofer"
                label-for="Chofer"
              >
                <b-form-input
                  v-model="chofer"
                  size="sm"
                  readonly
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mt-1"
            >
              <b-form-group
                label="Flota"
                label-for="flota"
              >
                <b-form-input
                  v-model="flota"
                  size="sm"
                  readonly
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mt-1"
            >
              <b-form-group
                label="Zona"
                label-for="zona"
              >
                <b-form-input
                  v-model="zona"
                  size="sm"
                  readonly
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mt-1"
            >
              <b-form-group
                label="Vendedor"
                label-for="vendedor"
              >
                <b-form-input
                  v-model="vend"
                  size="sm"
                  readonly
                />
              </b-form-group>
            </b-col>
          </b-col>
          <b-col
            md="12"
            class="d-flex justify-content-center align-items-center mt-1"
          >
            <b-col
              v-for="(detalle, index) in salida.resumen"
              :key="index"
              md="4"
              class="align-items-center"
            >
              <h7> {{ detalle.producto }} ({{ detalle.total }})</h7>
              <h7> VENDIDO = {{ detalle.cantidadvendida }}</h7>
            </b-col>
          </b-col>
        </b-col>
        <b-col
          md="12"
          class="mt-2 mr-2 mf-2"
          style="max-height: 180vh;overflow: auto;"
        >
          <h3 class="mb-2">
            Cuadre de caja
          </h3>
          <b-table
            :fields="fieldsImporte"
            :items="itemsImporteConTotales"
            empty-text="No se encontraron registros"
            :row-class="rowClass"
            :tbody-tr-class="customRowClass"
          >
            <template #cell(efectivo)="data">
              {{ parseFloat(data.item.efectivo).toFixed(2) }}
            </template>
            <template #cell(plin)="data">
              {{ parseFloat(data.item.plin).toFixed(2) }}
            </template>
            <template #cell(yape)="data">
              {{ parseFloat(data.item.yape).toFixed(2) }}
            </template>
            <template #cell(total)="data">
              {{ parseFloat(data.item.total).toFixed(2) }}
            </template>
            <template #cell(visa)="data">
              {{ parseFloat(data.item.visa).toFixed(2) }}
            </template>
            <template #cell(tranferencia)="data">
              {{ parseFloat(data.item.tranferencia).toFixed(2) }}
            </template>
            <template #cell(fise)="data">
              {{ parseFloat(data.item.fise).toFixed(2) }}
            </template>
            <template #cell(cliente)="data">
              <b-link
                v-b-tooltip.hover.top="`${data.item.nombreCliente} - ${data.item.nombreDocumento}`"
                class="font-weight-bold"
              >
                <b-avatar
                  size="32"
                  variant="light-success"
                >
                  <feather-icon
                    icon="UserIcon"
                    size="20"
                  />
                </b-avatar>
              </b-link>
              <span style="font-size: 12;font-weight: bold;">
                {{ data.item.direccion }}
              </span>
            </template>

            <template #cell(delivery)="data">
              <span style="font-size: 12;font-weight: bold;">
                {{ data.item.deliveryid }}
              </span>
            </template>
          </b-table>
        </b-col>
        <!-- <b-col
          md="12"
          class="mt-2 mr-2 mf-2"
        >
          <h3 class="mb-2">
            Resumen ventas de presentaciones
          </h3>
          <b-table
            :fields="fieldsProducto"
            :items="itemsProductoConTotales"
            empty-text="No se encontraron registros"
            :row-class="rowClass"
          >
            <template #cell(cliente)="data">
              <span :class="{ 'font-weight-bold': data.item.cliente === 'Totales' }">
                {{ data.item.cliente }}
              </span>
            </template>
          </b-table>
        </b-col> -->
        <b-col
          cols="12"
          md="2"
          class="mt-2"
        >
          <b-form-group
            label="Total Fise"
            label-for="totalFise"
          >
            <b-form-input
              v-model="totalFise"
              size="sm"
              readonly
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mt-2"
        >
          <b-form-group
            label="Total Efectivo"
            label-for="totalEfectivo"
          >
            <b-form-input
              v-model="totalEfectivo"
              size="sm"
              readonly
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mt-2"
        >
          <b-form-group
            label="Total Gastos"
            label-for="totalGasto"
          >
            <b-form-input
              v-model="totalGasto"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mt-2"
        >
          <b-form-group
            label="Total Cobros"
            label-for="totalCobro"
          >
            <b-form-input
              v-model="totalCobro"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mt-3"
        >
          <h2> Total Cuadre: {{ parseFloat(totalEfectivo - totalGasto).toFixed(2) }}</h2>
        </b-col>
      </b-row>
      <b-row
        class="text-center mb-2"
        align-v="center"
      >
        <b-col
          cols="12"
          md="4"
        />
        <b-col
          cols="12"
          md="4"
        >
          <b-button
            variant="primary"
            class="btn-icon"
            type="button"
            size="lg"
            @click="saveCuadre"
          >
            Guardar
            <feather-icon icon="SaveIcon" />
          </b-button>
        </b-col>
        <b-col
          cols="12"
          md="4"
        />
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  BCard, VBTooltip, BCol, BFormGroup, BFormDatepicker, BRow, BButton, BFormInput, BTable,
} from 'bootstrap-vue'
// BRow, BFormGroup, BForm, BFormInput, BButton, BTable, BDropdown, BDropdownItem,
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, computed } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import vSelect from 'vue-select'
import { useNotify } from '@/helpers/toast'
// import Ripple from 'vue-ripple-directive'
import store from '@/store'

export default {
  components: {
    BCard,
    BFormDatepicker,
    BCol,
    BRow,
    BFormGroup,
    // BForm,
    vSelect,
    BFormInput,
    // // BInputGroup,
    // // BInputGroupAppend,
    BButton,
    // // Form Validation
    // ValidationProvider,
    // ValidationObserver,
    BTable,
    // BDropdown,
    // BDropdownItem,
    // BFormDatepicker,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      required,
    }
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const userData = ref(JSON.parse(localStorage.getItem('userData')))
    console.log(notify)
    const titleForm = ref('')
    const zona = ref('')
    const flota = ref('')
    const chofer = ref('')
    const vend = ref('')
    const sortBy = ref(null)
    const vendedor = ref(null)
    const fecha = ref(null)
    const salida = ref(null)
    const isBusy = ref(false)
    const items = ref([])
    const totalEfectivo = ref(0)
    const totalCobro = ref(0)
    const totalGasto = ref(0)
    const totalFise = ref(0)
    const listSalida = ref([])
    const itemsImporte = ref([])
    const fieldsImporte = ref([
      { key: 'cliente_id', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'cliente', label: 'Cliente', sortable: true, thStyle: { width: '30%' } },
      { key: 'nrocomprobante', label: 'Comprobante', sortable: true, thStyle: { width: '5%' } },
      { key: 'deliveryid', label: 'Repartidor', sortable: true, thStyle: { width: '5%' } },
      // { key: 'efectivo', label: 'Efectivo', thStyle: { width: '5%' } },
      // { key: 'visa', label: 'Visa', thStyle: { width: '5%' } },
      // { key: 'plin', label: 'Plin', thStyle: { width: '5%' } },
      // { key: 'yape', label: 'Yape', thStyle: { width: '5%' } },
      // { key: 'tranferencia', label: 'Tranfer.', thStyle: { width: '5%' } },
      // { key: 'fise', label: 'Fise', thStyle: { width: '5%' } },
      { key: 'total', label: 'Pago', thStyle: { width: '5%' } },
      { key: 'observacion', label: 'Observacion', thStyle: { width: '5%' } },
      { key: 'hsistema', label: 'H.Sistema', thStyle: { width: '5%' } },
      { key: 'hdespacho', label: 'H.Despacho', thStyle: { width: '5%' } },
      { key: 'hentega', label: 'H.Entrega', thStyle: { width: '5%' } },
      { key: 'hpromedio', label: 'P.Atencion', thStyle: { width: '5%' } },
      // { key: 'tipoventa', label: 'T.Venta', thStyle: { width: '10%' } },
    ])
    const itemsProducto = ref([])
    const fieldsProducto = ref([
      { key: 'cliente_id', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'cliente', label: 'Cliente', sortable: true, thStyle: { width: '20%' } },
      { key: 'u05', label: 'u05', thStyle: { width: '5%' } },
      { key: 'u10', label: 'u10', thStyle: { width: '5%' } },
      { key: 'u15', label: 'u15', thStyle: { width: '5%' } },
      { key: 'u45', label: 'u45', thStyle: { width: '5%' } },
      { key: 's05', label: 's05', thStyle: { width: '5%' } },
      { key: 's10', label: 's10', thStyle: { width: '5%' } },
      // { key: 's15', label: 's15', thStyle: { width: '5%' } },
      { key: 's45', label: 's45', thStyle: { width: '5%' } },
      { key: 'v05', label: 'v05', thStyle: { width: '5%' } },
      { key: 'v10', label: 'v10', thStyle: { width: '5%' } },
      { key: 'v15', label: 'v15', thStyle: { width: '5%' } },
      { key: 'v45', label: 'v45', thStyle: { width: '5%' } },
    ])
    const selectVendedor = ref([])
    const getParametros = async () => {
      selectVendedor.value = []
      Vue.swal({
        title: 'Obteniendo Parametros',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          Vue.swal.showLoading()
          await store.dispatch('seguridad/USUARIO_ALL_SALES', { tipo_usuario: '-' })
            .then(response => {
              // console.log(response)
              response.forEach(value => {
                const { trabajador, ...resto } = value
                const nuevoObjeto = {
                  nombreCompleto: trabajador.nombreCompleto,
                  ...resto,
                  trabajador,
                }
                selectVendedor.value.push(nuevoObjeto)
              })
            })
          Vue.swal.close()
        },
      })
    }
    const itemsProductoConTotales = computed(() => {
      const itemsPre = [...itemsProducto.value]

      const totalRow = { cliente: 'Totales', cliente_id: null, u05: 0, u10: 0, u15: 0, u45: 0, s05: 0, s10: 0, s15: 0, s45: 0, v05: 0, v10: 0, v15: 0, v45: 0 }

      itemsPre.forEach(item => {
        Object.keys(totalRow).forEach(key => {
          if (key !== 'cliente' && key !== 'cliente_id' && item[key] != null) {
            totalRow[key] += Number(item[key])
          }
        })
      })
      return [...itemsPre, totalRow]
    })
    const itemsImporteConTotales = computed(() => {
      const itemsPre = [...itemsImporte.value]

      const totalRow = { cliente: 'Totales', cliente_id: null, idsalida: null, tipoventa: '', efectivo: 0, fise: 0, plin: 0, total: 0, tranferencia: 0, visa: 0, yape: 0 }

      itemsPre.forEach(item => {
        Object.keys(totalRow).forEach(key => {
          if (key !== 'cliente' && key !== 'cliente_id' && key !== 'idsalida' && key !== 'tipoventa' && item[key] != null) {
            totalRow[key] += Number(item[key])
          }
        })
        console.log({ item })
        totalEfectivo.value += Number(item.efectivo)
        totalFise.value += Number(item.fise)
      })
      return [...itemsPre, totalRow]
    })
    const verDetalleVentas = () => {
      itemsImporte.value = []
      itemsProducto.value = []
      let parametros = null
      if (salida.value !== null) {
        parametros = { salidaId: salida.value.idCilindroSalidaRetorno, vendedorId: '-1', fecha: fecha.value }
      } else {
        parametros = { salidaId: '-1', vendedorId: vendedor.value.idUsuario, fecha: fecha.value }
      }
      Vue.swal({
        title: 'Resumen de ventas.......',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          Vue.swal.showLoading()
          await store.dispatch('caja/CAJA_RESUMEN_CUADRE', parametros)
            .then(response => {
              // console.log(response)
              response.ventaCliente.forEach(value => {
                const { ...resto } = value
                const partCliente = (value.cliente).split('|')
                const nuevoObjeto = {
                  nombreCliente: partCliente[0],
                  nombreDocumento: partCliente[2],
                  direccion: partCliente[1],
                  ...resto,
                }
                itemsImporte.value.push(nuevoObjeto)
              })
              // itemsImporte.value = response.ventaCliente
              itemsProducto.value = response.ventaClienteProducto
              // console.log(itemsImporte.value)
            })
          Vue.swal.close()
        },
      })
    }
    const verResumenSalida = data => {
      // console.log(data)
      salida.value = data
      chofer.value = data.conductor.nombreCompleto
      zona.value = data.zona.descripcion
      flota.value = data.flota.placa
      vend.value = vendedor.value.nombreCompleto
      totalEfectivo.value = 0
      totalFise.value = 0
      totalGasto.value = 0
      verDetalleVentas()
    }
    const buscarSalida = () => {
      console.log(vendedor.value)
      listSalida.value = []
      Vue.swal({
        title: 'Buscando salidas sin liquidar',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          Vue.swal.showLoading()
          await store.dispatch('caja/CAJA_GET_SALIDA', { fecha: fecha.value, vendedorId: vendedor.value.trabajador.idTrabajador })
            .then(response => {
              if (response.length > 0) {
                listSalida.value = response
                Vue.swal.close()
                Vue.swal({
                  title: 'Selecionar salida del vendedor',
                  html: `
                  <select id="select-nombre" class="form-control">
                    ${listSalida.value.map(row => `<option value="${row.idCilindroSalidaRetorno}">${row.codigo} - ${row.fechaVbVigilanteSalida}</option>`).join('')}
                  </select>
                `,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Generar',
                  cancelButtonText: 'Cancelar',
                  customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-primary ml-1',
                  },
                  buttonsStyling: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                }).then(async result => {
                  // Cuando el usuario presiona "Guardar", puedes obtener el valor seleccionado
                  if (result.isConfirmed) {
                    const selectedNombre = document.getElementById('select-nombre').value
                    // Aquí puedes realizar la lógica para guardar con el nombre seleccionado
                    // Ejemplo de cómo encontrar el objeto trabajador según el nombre seleccionado
                    let trabajadorSeleccionado = 0
                    listSalida.value.forEach(row => {
                      if (row.idCilindroSalidaRetorno === Number(selectedNombre)) {
                        trabajadorSeleccionado = row
                      }
                    })
                    // console.log('Trabajador seleccionado:', trabajadorSeleccionado)
                    // Aquí puedes continuar con tu lógica para guardar o hacer lo que necesites
                    // console.log(trabajadorSeleccionado)
                    console.log(listSalida.value)
                    console.log(document.getElementById('select-nombre'))
                    console.log(selectedNombre)
                    console.log(trabajadorSeleccionado)
                    verResumenSalida(trabajadorSeleccionado)
                  }
                }).catch(error => {
                  console.error('Ha ocurrido un error:', error)
                  Vue.swal.close()
                })
              } else {
                itemsImporte.value = []
                itemsProducto.value = []
                salida.value = null
                Vue.swal.close()
                notify('Respuesta', 'No tiene ventas para liquidar en la fecha', 'danger')
              }
            })
          // Vue.swal.close()
        },
      })
    }
    const verCuadre = () => {
      // console.log(vendedor.value)
      // console.log(fecha.value)
      // console.log(userData.value.authorities[0].authority)
      if (userData.value.authorities[0].authority === 'ADMINISTRADOR VENTAS DISTRIBUIDOR') {
        buscarSalida()
      } else {
        verDetalleVentas()
      }
    }
    const rowClass = _itemData => (_itemData?.cliente === 'Totales' ? 'bg-light font-weight-bold' : '')
    const customRowClass = item => {
      if (!item) return ''

      if (item.cliente === 'Totales') {
        return 'bg-light font-weight-bold'
      }

      if (item.tipoventa === 'CREDITO') {
        return 'tr-credito font-size-10' // Puedes usar otra clase de Bootstrap si prefieres
      }

      return ''
    }
    const saveCuadre = () => {
      console.log('Guardar cuadre')
      const partFecha = (fecha.value).split('-')
      const parametros = { fecha: `${partFecha[2]}/${partFecha[1]}/${partFecha[0]}`, salida: null, totalCobro: totalCobro.value, totalCuadre: (parseFloat(totalEfectivo.value - totalGasto.value).toFixed(2)), totalEfectivo: totalEfectivo.value, totalFise: totalFise.value, totalGasto: totalGasto.value, vendedor: null }
      if (salida.value !== null) {
        parametros.salida = { idCilindroSalidaRetorno: salida.value.idCilindroSalidaRetorno }
      } else {
        parametros.vendedor = { idUsuario: vendedor.value.idUsuario }
      }
      Vue.swal({
        title: 'Guardar liquidacion.......',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          Vue.swal.showLoading()
          await store.dispatch('caja/LIQUIDACION_CREATE', parametros)
            .then(response => {
              console.log(response)
              Vue.swal.close()
              // console.log(itemsImporte.value)
              // Vue.$router.push({ name: 'rt-caja-liquidacion' })
              window.location.reload()
            })
          Vue.swal.close()
        },
      })
    }

    getParametros()
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation()

    return {
      rowClass,
      customRowClass,
      refFormObserver,
      getValidationState,
      resetForm,
      titleForm,
      selectVendedor,
      items,
      sortBy,
      isBusy,
      getParametros,
      vendedor,
      fecha,
      verCuadre,
      userData,
      buscarSalida,
      listSalida,
      verResumenSalida,
      salida,
      zona,
      flota,
      chofer,
      vend,
      verDetalleVentas,
      fieldsImporte,
      itemsImporte,
      fieldsProducto,
      itemsProducto,
      itemsProductoConTotales,
      itemsImporteConTotales,
      totalEfectivo,
      totalCobro,
      totalGasto,
      totalFise,
      saveCuadre,
    }
  },
}
</script>

  <style>
  .tr-credito {
    background-color: #f6caca;
  }
  .tabla-pequena {
    font-size: 11px;
  }
  </style>
